import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/* Collaboration callables (Admin-SDK backed — see functions/index.js). Membership
   and plan creation go through these, never direct client writes. */
export const createPlanFn = httpsCallable(functions, 'createPlan');
export const invitePlanCollaboratorFn = httpsCallable(functions, 'invitePlanCollaborator');
export const removeCollaboratorFn = httpsCallable(functions, 'removeCollaborator');
